
export default function CultureSection() {
  const cultureValues = [
    {
      icon: 'ri-heart-fill',
      title: '匠心传承',
      description: '秉承千年茶道精神，以匠心精神对待每一片茶叶，传承中华茶文化精髓。'
    },
    {
      icon: 'ri-shield-check-fill',
      title: '诚信至上',
      description: '坚持"三真"承诺，以诚信为本，让每一位客户都能放心选择我们的产品。'
    },
    {
      icon: 'ri-rocket-fill',
      title: '创新发展',
      description: '在传承中创新，用现代科技手段提升传统茶业，引领行业发展方向。'
    },
    {
      icon: 'ri-customer-service-fill',
      title: '客户至上',
      description: '以客户需求为导向，提供优质产品和贴心服务，成就客户的品茶体验。'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#663333] mb-4">
            企业文化
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            传承茶道精神，践行企业价值
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
        </div>

        {/* 核心价值观 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {cultureValues.map((value, index) => (
            <div key={index} className="text-center space-y-4">
              <div className="w-16 h-16 flex items-center justify-center bg-[#cc9966] rounded-full mx-auto">
                <i className={`${value.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#663333]">
                {value.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>

        {/* 企业文化详细介绍 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 左侧内容 */}
          <div className="space-y-6">
            <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#663333]">茶道精神 匠心传承</h3>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-1">敬茶如敬人</h4>
                  <p className="text-xs sm:text-sm text-gray-600">对每一片茶叶都怀着敬畏之心，精心呵护，用心制作。</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-1">品质为先</h4>
                  <p className="text-xs sm:text-sm text-gray-600">不断追求更高的品质标准，永不妥协于平庸。</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-1">传承创新</h4>
                  <p className="text-xs sm:text-sm text-gray-600">在传承传统茶文化的同时，积极拥抱现代科技创新。</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-2 h-2 bg-[#cc9966] rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <h4 className="text-sm sm:text-base font-semibold text-[#663333] mb-1">共享共赢</h4>
                  <p className="text-xs sm:text-sm text-gray-600">与合作伙伴、客户、员工共同成长，实现多方共赢。</p>
                </div>
              </div>
            </div>
          </div>

          {/* 右侧图片 */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/94975a5c57748f9235830a92d8becc69.jpg"
              alt="企业文化"
              className="w-full h-full object-cover object-top rounded-2xl shadow-lg"
            />
          </div>
        </div>

        {/* 工作环境 */}
        <div className="mt-16 bg-[#f5f5f5] rounded-2xl p-8 lg:p-12">
          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-[#663333] text-center mb-8">
            工作环境与福利
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-[#cc9966]/20">
              <div className="w-12 h-12 flex items-center justify-center bg-[#cc9966] rounded-full mb-4">
                <i className="ri-building-fill text-xl text-white"></i>
              </div>
              <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-[#663333] mb-2">现代化办公</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                宽敞明亮的办公环境，配备先进的办公设备和茶品体验区
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-[#cc9966]/20">
              <div className="w-12 h-12 flex items-center justify-center bg-[#cc9966] rounded-full mb-4">
                <i className="ri-graduation-cap-fill text-xl text-white"></i>
              </div>
              <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-[#663333] mb-2">培训成长</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                完善的培训体系，定期技能提升课程，支持员工职业发展
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-[#cc9966]/20">
              <div className="w-12 h-12 flex items-center justify-center bg-[#cc9966] rounded-full mb-4">
                <i className="ri-gift-fill text-xl text-white"></i>
              </div>
              <h4 className="text-sm sm:text-base lg:text-lg font-semibold text-[#663333] mb-2">丰厚福利</h4>
              <p className="text-xs sm:text-sm text-gray-600">
                五险一金、带薪年假、节日礼品、员工茶品福利等
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}